export const DetachMixin = {
  install (Vue, options) {
    Vue.mixin({
      methods: {
        detach: function (value) {
          return JSON.parse(JSON.stringify(value))
        }
      }
    })
  }
}

export const detach = value => {
  return JSON.parse(JSON.stringify(value))
}
